import React from "react"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, FontIcon } from "material-ui"
import strings from "../../localization/strings"
import Table from "../../components/common/Table"
import { IAccrualAdjustment } from "../../models"
import { green500 } from "material-ui/styles/colors"

interface IProps {
	readonly: boolean
	adjustments: IAccrualAdjustment[]
	selectedAdjustments: IAccrualAdjustment[]
	total: number
	offset: number
	limit: number
	limitOptions: number[]
	onPageClick(offset: number): void
	handleUpdate(editAdjustment: IAccrualAdjustment): void
	onLimitChange(limit: number): void
	handleSelectedAdjustments(adjustments: IAccrualAdjustment[]): void
}

const AdjustmentsTable: React.SFC<IProps> = (props: IProps) => {
	return (
		<Table
			readonly={props.readonly}
			items={props.adjustments}
			handleClickRow={adjustment => props.handleUpdate(adjustment)}
			handleSelect={props.handleSelectedAdjustments}
			total={props.total}
			offset={props.offset}
			limit={props.limit}
			limitOptions={props.limitOptions}
			onPageClick={props.onPageClick}
			onLimitChange={props.onLimitChange}
		>
			<TableHeader>
				<TableRow>
					<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Adjustment}</TableHeaderColumn>
					<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Allow_Manual_Adjustment}</TableHeaderColumn>
					<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Adjustment_Value}</TableHeaderColumn>
				</TableRow>
			</TableHeader>
			<TableBody deselectOnClickaway={false}>
				{props.adjustments.map((adjustment, index) => {
					return (
						<TableRow data-intercom-target={index === 0 && "AdjustmentTable-OpenItemDetails"} key={adjustment.Id} selected={props.selectedAdjustments.find(item => item.Id === adjustment.Id) ? true : false}>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer", }} title={adjustment.Adjustment}>
								{adjustment.Adjustment}
							</TableRowColumn>
                            <TableRowColumn style={{ textAlign: "left", cursor: "pointer", }}>
								{adjustment.AllowManualAdjustment &&
									<FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
								}
							</TableRowColumn>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer", }} title={adjustment.AdjustmentValue}>
								{adjustment.AdjustmentValue}
							</TableRowColumn>
						</TableRow>
					)
				})}
			</TableBody>
		</Table>
	)
}

export default AdjustmentsTable